import { stats } from '@/mocks/home';
import ScrollReveal from './ScrollReveal';

export default function Stats() {
  return (
    <section className="bg-white">
      <div className="px-4 md:px-8 lg:px-16 xl:px-24">
        <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 py-4">
          {stats.map((stat, i) => (
            <ScrollReveal key={stat.label} delay={i * 80}>
              <div className="group h-full flex flex-col items-center justify-center py-10 md:py-14 text-center rounded-lg border-2 border-gray-900 bg-white shadow-[4px_4px_0_0_#ff9db8] hover:shadow-[4px_4px_0_0_#1a1a1a] hover:-translate-y-1 transition-all duration-300 relative overflow-hidden">
                <div className="absolute top-2 right-2 w-8 h-8 halftone-pink pointer-events-none" />
                <span className="font-serif text-4xl md:text-5xl font-bold text-gray-900">
                  {stat.number}
                </span>
                <span className="mt-2 text-sm text-gray-400 tracking-widest">{stat.label}</span>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}